import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='')
  apiUrl = `${protocol}//${hostname}/api`

const getProviderFileAuditsRequested = () => ({
  type: types.GET_PROVIDER_FILE_AUDITS_REQUESTED,
  payload: null
})

const getProviderFileAuditsRejected = (error: any) => ({
  type: types.GET_PROVIDER_FILE_AUDITS_REJECTED,
  payload: error
})

const getProviderFileAuditsFulfilled = (data: Array<any>) => ({
  type: types.GET_PROVIDER_FILE_AUDITS_FULFILLED,
  payload: data
})

export const getProviderFileAudits = (id: number, token: string) => {
  return (dispatch: any) => {
    dispatch(getProviderFileAuditsRequested())
    const apiURL = `${apiUrl}/provider/audits/${id}`
    request
      .get(apiURL)
      .set('Accept', 'application/json')
      .set('access-token',token)
      .then((response) => {
        dispatch(getProviderFileAuditsFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getProviderFileAuditsRejected(error))
      })
  }
}

const updateProviderFileAuditItemRequested = () => ({
  type: types.UPDATE_PROVIDER_FILE_AUDIT_ITEM_REQUESTED,
  payload: null
})

const updateProviderFileAuditItemRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_FILE_AUDIT_ITEM_REJECTED,
  payload: error
})

const updateProviderFileAuditItemFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_FILE_AUDIT_ITEM_FULFILLED,
  payload: data
})

export const updateProviderFileAuditItem = (token: string, data: any) => {
  return (dispatch: any) => {
    dispatch(updateProviderFileAuditItemRequested())
    request
      .put(`${apiUrl}/providerFileAuditItem/${data.get('itemType') === 'Active Certificate/Licensure' ? 'provider' : 'organization'}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderFileAuditItemFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderFileAuditItemRejected(error))
      })
  }
}

export const setProviderFileAudit = (providerFileAuditId: number) =>({
  type: types.SET_SELECTED_PROVIDER_FILE_AUDIT,
  payload: providerFileAuditId
})